export default "__VITE_ASSET__B$oIS0jF__"